import React from "react";
import {  ListItem, Li } from "./Components";
import { Typography } from "@material-ui/core";
import lon_haz_lev from "../img/sswpIcons/LoneWorkingViolence/lon_haz_lev.png";
import lon_acc_att from "../img/sswpIcons/LoneWorkingViolence/lon_acc_att.png";
import lon_com_ala from "../img/sswpIcons/LoneWorkingViolence/lon_com_ala.png";
import lon_con_per_che from "../img/sswpIcons/LoneWorkingViolence/lon_con_per_che.png";
import lon_lia_per from "../img/sswpIcons/LoneWorkingViolence/lon_lia_per.png";
import lon_ris_ass_tra from "../img/sswpIcons/LoneWorkingViolence/lon_ris_ass_tra.png";
import lon_sit_spe_met from "../img/sswpIcons/LoneWorkingViolence/lon_sit_spe_met.png";
export default {
    icon: lon_haz_lev,
    name: "Lone Working Violence",
    text: "",
    icons: {
        lon_ris_ass_tra: {
            name: "Risk Assess/ Training",
            icon: lon_ris_ass_tra,
            text: (
                <ul>
                    <ListItem text="Assess the risk of an accident or emergency, including inadequate provision of first aid. All lone workers must be know how to respond correctly in an emergency or violent situation." />
                    <ListItem text="Assess the risk of sudden illness" />
                    <ListItem text=" Assess the requirements for rest, hygiene and welfare facilities" />
                    <ListItem text="Assess the risk of violence from members of the public and/re intruders" />
                    <ListItem text=" Select appropriate controls, including; communication, periodic checks, automatic warning devices, PPE, health surveillance, first aid kits, SOPs, locking and securing places of work, functioning incident reporting systems, provision of counselling" />
                    <ListItem text="Lone workers should receive appropriate training on the hazards present and the controls that will be used." />
                    <ListItem text=" There must be clear limits on what can and cannot be done while lone working" />
                    <ListItem text="There must be adequate supervision of lone working activities, and should include periodic checks and discussions on safety and health issues. It should not be solely left to the lone worker to evaluate adequate control." />
                </ul>
            )
        },
        lon_lia_per: {
            name: "Liason / Permission",
            icon: lon_lia_per,
            text: (
                <ul>
                    <ListItem text="If you are entering property, you need to have either the permission of the owner, or the authority to enter. When organising, check to ensure that hazards have been identified (openings, dangerous structures, ground stability/firmness, electric services, other work activities, animals etc) and that you have the necessary arrangements and controls in place." />
                </ul>
            )
        },
        lon_com_ala: {
            name: "Communication / Alarm",
            icon: lon_com_ala,
            text: (
                <ul>
                    <ListItem text="This covers “man down” alarm systems, check-in check-out systems, phone/text systems to colleagues/ supervisor, when lone working" />
                    <ListItem text="All persons concerned should know the location of the lone worker, and reporting (including timing of) of alarms raised and necessary response actions." />
                </ul>
            )
        },
        lon_con_per_che: {
            name: "Controlled Periodic Checks",
            icon: lon_con_per_che,
            text: (
                <ul>
                    <ListItem text="This includes communication at fixed times, check-in check-out systems, phone/text systems to colleagues/ supervisor, when lone working" />
                    <ListItem text="All persons concerned should know the location of the lone worker, and reporting (including timing of) of alarms raised and necessary response actions." />
                </ul>
            )
        },
        lon_acc_att: {
            name: "Accompanied / Attended",
            icon: lon_acc_att,
            text: (
                <ul>
                    <ListItem text="Certain types of hazards or work types will require more than one person to attend. Each person needs to understand their role and duty." />
                </ul>
            )
        },
        lon_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: lon_sit_spe_met,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};
